import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorBookingItemTree } from '../editor-booking-item-tree/editor-booking-item-tree.model';
import {
  EditorBookingItemTreeStore
} from '../editor-booking-item-tree/editor-booking-item-tree.store';
import {
  EditorBookingItemTreeDataEditStore
} from '../editor-booking-item-tree-data-edit/editor-booking-item-tree-data-edit.store';
import { EditorDialogStore } from '../editor-dialog/editor-dialog.store';
import { EXAM_TYPES_OPTIONS } from "@fry/connections/lib/connection";


@Component({
  // tslint:disable-next-line:component-selector
  selector: '[eas-editor-booking-item-tree-exam-type]',
  templateUrl: './editor-booking-item-tree-exam-type.component.html',
  standalone: false,
})
export class EditorBookingItemTreeExamTypeComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  itemTree: EditorBookingItemTree;

  examTypeName: string = null;

  constructor(
    private itemTreeStore: EditorBookingItemTreeStore,
    private itemTreeDataEditStore: EditorBookingItemTreeDataEditStore,
    private itemDialogStore: EditorDialogStore
  ) {

  }

  ngOnInit() {
    let examTypeNames = EXAM_TYPES_OPTIONS;
    this.itemTreeStore.itemTree$.subscribe({
      next: itemTree => {
        this.examTypeName = itemTree === null ? null : itemTree.getExamTypeName(examTypeNames);
      }
    })

    this.itemTreeStore.itemTree$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(itemTree => this.itemTree = itemTree);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onEdit() {
    this.itemTreeDataEditStore.startEditing({ name: 'examType' });
    this.itemDialogStore.editBookingItemTree();
    return false;
  }
}
